<template>
  <div class="row">
    <div class="col-md-4 mb-4 cardDiv" v-for="(item, i) in planos" :key="i">
      <div class="cardBorder">
        <p v-if="item.recomendado == 1" class="text-center recomendado">RECOMENDADO</p>
        <b-card
          :title="item.nome"
          :img-src="item.url_img"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem;"
          class="mb-2"
        >
          <b-card-text>
            {{item.descricao}}
          </b-card-text>

          <p v-if="item.recomendado == 1" class="mt-3 text-center price">{{item.preco}}</p>
          <p v-else class="mt-5 text-center price">{{item.preco}}</p>

          <button class="btn btn-success btn-block mt-2" @click="assinarPlano(item.id, item.preco)">Assinar plano</button>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
  name:'ArtesRedeSociais',
  mixins: [makeToast],
  data() {
    return {
      planos: null
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.showPlanos();
  },

  methods: {
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/todosPlanos')
      .then((response) => {
        this.planos = response.data;
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },

    assinarPlano(tipo, preco) {
      const data = {
        tipo_plano: tipo,
        price: preco,
        usuario_id: this.dadosUsuario.id,
        nome: this.dadosUsuario.nome_usuario,
        email: this.dadosUsuario.email,
        cpf_cnpj: this.dadosUsuario.cnpj,
        street: this.dadosUsuario.informacoes.endereco,
        district: this.dadosUsuario.informacoes.bairro,
        number: this.dadosUsuario.informacoes.numero,
        zip_code: this.dadosUsuario.informacoes.cep,
        complement: this.dadosUsuario.informacoes.complemento,
        city: this.dadosUsuario.informacoes.cidade.nome,
        state: this.dadosUsuario.informacoes.estado.uf,
      }
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/solicitarPlano', data)
      .then((response) => {
        if(response.data.id) {
          this.$router.push({ name: 'lojista-cartão-credito', params: { id: response.data.id }});
        } else {
          this.makeToast('Oopss', 'Oops! Parece que houve um erro ao assinar plano!', 'danger')
        }
      })
      .catch(() => {
        this.makeToast('Oopss', 'Oops! Parece que houve um erro ao assinar plano!', 'danger')
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    }
  }
}
</script>

<style scoped>
.cardDiv {
  display: flex;
  justify-content: center;
}
.recomendado {
  font-size: 25px;
  color: #FFF;
  background-color: #ff4a4a;
}
.cardBorder {
  border: 1px solid #ff4a4a;
  border-radius: 10px;
  padding: 25px;
}
.price {
  font-size: 25px;
  font-weight: bold;
}
</style>